import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core'
import { LoadingService } from '@app/core/state/loading/loading.service'
import { Observable } from 'rxjs'

@Component({
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LoadingBarComponent implements OnInit {
  constructor(private loadingService: LoadingService) {}

  isLoading$: Observable<boolean>

  ngOnInit(): void {
    this.isLoading$ = this.loadingService.isLoading$
  }
}
